import React, { useState } from "react";
import { Input, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';

const MaterialLikeInput = ({
  label,
  value,
  onChange,
  readOnly,
  required,
  loading,
  autoComplete = "off",
  name,
  type = "text",
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <div className={`mui-input-container ${focused || value || value === 0 ? "focused" : ""}`}>
      <label className="mui-label">
        {/* {(focused || value) && required && <span className="required-star">*</span>} */}
        {required && <span className="required-star">*</span>}{label}
      </label>

      <Input
        value={value}
        suffix={
          loading ? (
            <Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} />
          ) : null
        }
        name={name || "fake-field"}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onWheel={(e) => e.target.blur()}
        className="mui-input"
        bordered={false}
        readOnly={readOnly}
        autoComplete={autoComplete || "new-password"}
        type={type}
      />

      <span className="mui-underline" />
    </div>
  );
};

export default MaterialLikeInput;
